module.exports = __webpack_public_path__ + "static/media/Empty-compartment.4c83fe56.svg";